import { PostHogProvider } from "posthog-js/react";
import type { PostHogConfig } from "posthog-js";
import { POSTHOG_HOST, POSTHOG_KEY, POSTHOG_UI_HOST } from "./utils/consts";

const options: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  ui_host: POSTHOG_UI_HOST,
  before_send: (event) => {
    try {
      // Drop known bot/scanner runtime errors
      if (event?.event === "error_occurred") {
        const msg = String(event?.properties?.error_message || "");
        const isBotSignature =
          /Object Not Found Matching Id:\d+/.test(msg) &&
          /MethodName:update/.test(msg) &&
          /ParamCount:4/.test(msg);
        if (isBotSignature) return null;
      }

      // Heuristic: drop events from obvious bot user agents
      const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
      if (/\bCefSharp\b|\bHeadlessChrome\b/i.test(ua)) return null;
    } catch {
      // Ignore filtering errors and allow event through
    }
    return event;
  },
  rate_limiting: {
    events_burst_limit: 1000,
    events_per_second: 100,
  },
};

export const Hog = ({ children }: { children: React.ReactNode }) => {
  if (import.meta.env.MODE === "development") {
    return <>{children}</>;
  }
  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};
